export const STORAGE_PERSON_ID = 'person-id'
export const STORAGE_LOGIN_TYPE = 'last-login-type'
